module.exports = " <div class=routes-fieldtype-wrapper> <grid-fieldtype :data=data :config=gridConfig></grid-fieldtype> <input type=hidden :name=name :value=\"data | json\"/> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/RoutesFieldtype.vue
// module id = 734
// module chunks = 0